<template>
  <!-- Now this page has no links on site (instead used popup LeadsGridContentEdit), only directly in browser "/ContactForms/Edit?Id=" -->

  <main class="page-leadedit">
    <div class="container-wide">
      <div v-if="contactForm">
        <div class="title-wrapper">
          <h1 class="page-title">
            {{ $t('Leads.LeadEditPageTitle', { name: contactForm.FullName }) }}
          </h1>
          <b-button type="is-primary" class="is-icon" size="is-small" @click="back()">
            <span>{{ $t('Back') }}</span>
          </b-button>
        </div>
        <div class="toolbar">
          <div class="toolbar-item">
            <b-button type="is-primary" :disabled="contactForm.IsInProcess || contactForm.ExternalCrmId > 0" @click="changeSaleStatus(LeadStatus.InProcess)">
              <div class="button-inner">
                <i class="material-icons" v-if="contactForm.IsInProcess">done</i>
                <span>{{ $t('Leads.Grid.Columns.IsInProcess') }}</span>
              </div>
            </b-button>
          </div>
          <div class="toolbar-item">
            <b-button type="is-danger" :disabled="contactForm.IsBad || contactForm.ExternalCrmId > 0" @click="changeSaleStatus(LeadStatus.NotGood)">
              <div class="button-inner">
                <i class="material-icons" v-if="contactForm.IsBad">done</i>
                <span>{{ $t('Leads.Grid.Columns.IsBad') }}</span>
              </div>
            </b-button>
          </div>
          <div class="toolbar-item">
            <b-button type="is-warning" :disabled="contactForm.Meeting || contactForm.ExternalCrmId > 0" @click="changeSaleStatus(LeadStatus.Meeting)">
              <div class="button-inner">
                <i class="material-icons" v-if="contactForm.Meeting">done</i>
                <span>{{ $t('Leads.Grid.Columns.Meeting') }}</span>
              </div>
            </b-button>
          </div>
          <div class="toolbar-item">
            <b-button type="is-success" :disabled="contactForm.IsClosed || contactForm.ExternalCrmId > 0" @click="changeSaleStatus(LeadStatus.Closed)">
              <div class="button-inner">
                <i class="material-icons" v-if="contactForm.IsClosed">done</i>
                <span>{{ $t('Leads.Grid.Columns.IsClosed') }}</span>
              </div>
            </b-button>
          </div>
          <div class="toolbar-item">
            <b-field>
              <b-switch @input="onFavouriteChange($event)" :disabled="!leadEditViewModel.EditAllLeads" :value="leadEditViewModel.ContactForm.Favourite">{{ $t("Leads.Favourite") }}</b-switch>
            </b-field>
          </div>
        </div>
        <div class="lead-form" v-if="contactForm">
          <div class="lead-field" v-if="leadEditViewModel.ShowDealsAmount">
            <b-field :label="$t('Leads.Grid.Columns.Amount')">
              <b-input :value="contactForm.DealAmount" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="leadEditViewModel.ShowSalesman">
            <b-field :label="$t('Leads.Columns.AssigneeName')" v-if="leadEditViewModel.IsShared">
              <b-input :value="contactForm.UserId" disabled></b-input>
            </b-field>
            <b-field :label="$t('Leads.Assignee')" v-if="!leadEditViewModel.IsShared">
              <b-select expanded :disabled="contactForm.ExternalCrmId > 0"
                    :placeholder="$t('Leads.Grid.Columns.AssigneeName')" v-model="contactForm.UserId"
                    @change.native="save()">
                <option v-for="assignee in assignees"
                      :value="assignee.SalesmanID"
                      :key="assignee.SalesmanID">
                  {{ assignee.SalesmanName }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="lead-field" v-if="leadEditViewModel.ShowFullname">
            <b-field :label="$t('Leads.Grid.Columns.FullName')">
              <b-input :value="contactForm.FullName" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="leadEditViewModel.ShowPhone">
            <b-field :label="$t('Leads.Grid.Columns.Phone')">
              <b-input :value="contactForm.Phone" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="leadEditViewModel.ShowEmail">
            <b-field :label="$t('Leads.Grid.Columns.Email')">
              <b-input :value="contactForm.Email" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field">
            <b-field :label="$t('Leads.Grid.Columns.Company')">
              <b-input :value="contactForm.Company" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="!hasRestriction(LeadPermissionType.Source)">
            <b-field :label="$t('Leads.Grid.Columns.FoundMetadataType')">
              <b-input :value="contactForm.MetadataTypeFromUrl" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="!hasRestriction(LeadPermissionType.Campaigns)">
            <b-field :label="$t('Leads.Grid.Columns.CampaignTitle')">
              <b-input :value="contactForm.CampaignTitle" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="!hasRestriction(LeadPermissionType.Source)">
            <b-field :label="$t('Leads.Grid.Columns.MetadataTypeFromChannel')">
              <b-input :value="contactForm.MetadataTypeFromChannel" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field">
            <b-field :label="$t('Leads.Grid.Columns.CallStatus')">
              <b-input :value="contactForm.CallStatus" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field">
            <b-field :label="$t('Leads.Grid.Columns.SaleStatus')">
              <b-input :value="contactForm.SaleStatus" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field" v-if="!hasRestriction(LeadPermissionType.LeadsScreenKeywords)">
            <b-field :label="$t('Leads.Grid.Columns.Keyword')">
              <b-input :value="contactForm.Keyword" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field full-width-field" v-if="leadEditViewModel.ShowOtherData">
            <b-field :label="$t('Leads.Grid.Columns.Data')">
              <b-input type="textarea" :value="contactForm.Data" disabled></b-input>
            </b-field>
          </div>
          <div class="lead-field full-width-field" v-if="!hasRestriction(LeadPermissionType.Url)">
            <label class="label">{{ $t('Leads.Grid.Columns.FormUrl') }}</label>
            <div v-if="contactForm.FormUrl">
              <a :href="contactForm.FormUrl" target="_blank">{{ contactForm.FormUrl }}</a>
            </div>
            <div v-if="!contactForm.FormUrl">{{ $t('None') }}</div>
          </div>
          <div class="lead-field full-width-field" v-if="!hasRestriction(LeadPermissionType.Referal)">
            <label class="label">{{ $t('Leads.Grid.Columns.UrlReferrer') }}</label>
            <div v-if="contactForm.UrlReferrer">
              <a :href="contactForm.UrlReferrer" target="_blank">{{ contactForm.UrlReferrer }}</a>
            </div>
            <div v-if="!contactForm.UrlReferrer">{{ $t('None') }}</div>
          </div>
          <div class="lead-field full-width-field">
            <label class="label">{{ $t('Leads.Grid.Columns.UserIp') }}</label>
            <div>{{ contactForm.UserIp }}</div>
          </div>
          <div class="lead-field full-width-field">
            <div class="notes">
              <p class="label">{{ $t('Leads.CrmNotes') }}</p>
              <div v-for="note in leadEditViewModel.LeadNotes" :key="leadNoteStableKey(note)" class="card">
                <div class="card-header">
                  <span>{{ formatDate(note.CreatedDate) }}</span>
                  <span v-if="note.UserName" class="has-text-grey is-size-7"> — {{ note.UserName }}</span>
                </div>
                <div class="card-block">{{ note.Note }}</div>
              </div>
              <div v-if="!leadEditViewModel.LeadNotes.length" class="notes-empty has-text-grey">{{ $t('Leads.CrmNotesEmpty') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-notification 
        v-model="notification.isActive" 
        aria-close-label="Close notification">
        {{ notification.text }}
    </b-notification>
  </main>
</template>

<script lang="ts">
import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMq from "vue-mq";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { Meta } from "@/decorators/MetaDecorator";
import { Lead, LeadEditViewModel, UpdateLeadResponse } from "@/models/leads/Lead";
import { leadNoteStableKey } from "@/models/leads/LeadNote";
import { CompanyPermission, LeadPermissionType } from "@/models/leads/CompanyPermission";
import { LeadStatus } from "@/models/leads/LeadStatus";
import { Assignee } from "@/models/MultiselectItem";
import { MenuLink, UserData } from "@/models/UserData";
import HelperService from "@/services/HelperService";
import ApiService, { AssigneesForClientPayload } from "@/services/api/ApiService";

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

Vue.use(Loading, {
    color: "#0093d0",
    width: 32,
    height: 32,
    backgroundColor: "#ffffff",
    opacity: 0.5,
    zIndex: 999
});

const namespace = "leadsModule";

@Component
export default class LeadEdit extends Vue {

  @Meta
  myMetaConfig() {
    return {
      title: i18n.t("Leads.EditTitle").toString()
    };
  }

  //#region Vuex getters and actions

  @Getter("assignees", { namespace }) assignees!: Assignee[];
  @Getter("userData", { namespace: "mainModule" }) userData!: UserData;
  @Getter("leadEditViewModel", { namespace }) leadEditViewModel!: LeadEditViewModel;
  @Action("getAssigneesForClient", { namespace }) getAssigneesForClient!: (payload: AssigneesForClientPayload) => Promise<Assignee[]>;
  @Action("getLeadEditViewModel", { namespace }) getLeadEditViewModel!: (id: number) => Promise<LeadEditViewModel>;
  @Action("setLeadEditViewModel", { namespace }) setLeadEditViewModel!: (leadEditViewModel: LeadEditViewModel) => Promise<void>;

  //#endregion Vuex getters and actions


  //#region Properties

  LeadPermissionType: any = LeadPermissionType;
  LeadStatus: any = LeadStatus;

  leadNoteStableKey = leadNoteStableKey;
  
  isLoading = false;
  notification: Notification = {
    isActive: false,
    text: ''
  };
  
  //#endregion Properties


  //#region Watchers

  @Watch("leadEditViewModel", { immediate: true })
  onLeadEditViewModelChange(newLeadEditViewModel: LeadEditViewModel, oldLeadEditViewModel: LeadEditViewModel): void {
    if (!newLeadEditViewModel) {
      return;
    }
    this.getAssigneesForClient({
      assigneeId: newLeadEditViewModel.ContactForm.UserId,
      companyId: newLeadEditViewModel.ContactForm.CompanyId
    });
    // this.leadEditViewModel.ShowFullname = false;
  }

  //#endregion Watchers


  //#region Getters

  get contactForm(): Lead {
    return this.leadEditViewModel?.ContactForm;
  }

  //#endregion Getters


  //#region Lifecycle

  mounted() {
    this.getLeadEditViewModel(Number(HelperService.getQueryValueIgnoreCase(this.$route.query, "Id")));
  }

  //#endregion Lifecycle


  //#region Handlers

  back() {
    if (window.history.state) {
      this.$router.back();
    } else {
      const menuLink: MenuLink | undefined = this.userData.MenuLinks?.find((i: MenuLink) => i.Href.indexOf("ContactForms") >= 0);
      if (menuLink) {
        this.$router.push(menuLink.Href);
      }
    }
  }

  changeSaleStatus(status: LeadStatus) {
    if (!this.leadEditViewModel.EditAllLeads) {
      HelperService.showError(i18n.t("NotAllowed").toString());
      return;
    }
    switch (status) {
      case LeadStatus.InProcess:
        this.leadEditViewModel.ContactForm.IsInProcess = true;
        break;
      case LeadStatus.NotGood:
        this.leadEditViewModel.ContactForm.IsBad = true;
        break;
      case LeadStatus.Meeting:
        this.leadEditViewModel.ContactForm.Meeting = true;
        break;
      case LeadStatus.Closed:
        this.leadEditViewModel.ContactForm.IsClosed = true;
        break;
    }
    if (status === LeadStatus.NotGood || status === LeadStatus.Meeting || status === LeadStatus.Closed) {
      this.leadEditViewModel.ContactForm.IsInProcess = false;
    } else if (status === LeadStatus.InProcess) {
      this.leadEditViewModel.ContactForm.IsBad = false;
      this.leadEditViewModel.ContactForm.Meeting = false;
      this.leadEditViewModel.ContactForm.IsClosed = false;
    }
    this.save();
  }

  public onFavouriteChange(favourite: boolean): void {
    this.leadEditViewModel.ContactForm.Favourite = favourite;
    this.save();
  }

  save() {
    this.setLeadEditViewModel(this.leadEditViewModel);
    if (!this.leadEditViewModel.EditAllLeads) {
      HelperService.showError(i18n.t("NotAllowed").toString());
      return;
    }
    let loader = this.$loading.show();
    ApiService.updateLead(this.leadEditViewModel.ContactForm).then((response: UpdateLeadResponse) => {
      if (response.success) {
        HelperService.showNotification(response.message, "is-success", "is-top-right", 5000);
      } else {
        HelperService.showError(response.message, () => {
          location.reload();
        });
      }
      loader.hide();
    })
  }

  //#endregion Handlers


  //#region Private methods

  formatDate(date: Date) {
    return moment(date).format("DD.MM.YYYY");
  }

  hasRestriction(leadPermissionType: LeadPermissionType): boolean {
    let result = true;
    if (this.leadEditViewModel) {
      result = this.leadEditViewModel.ActiveRestictions
            .map((i: CompanyPermission) => i.Restriction)
            .indexOf(leadPermissionType) >= 0;
    }
    return result;
  }

  //#endregion Private methods
}

interface Notification {
  isActive: boolean;
  text: string;
}

</script>

<style lang="scss" scoped>

h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 1rem 0;
}

.page-leadedit {

  .lead-form {
    background: #fff;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fill, 32%);
    justify-content: space-between;
    margin: 1rem 0 0;
    padding: 1rem;

    @media (max-width: 991px) {
      display: block;
    }

    .lead-field {
      margin-bottom: 1rem;

      &.full-width-field {
        grid-column: 1 / 4;
      }
    }

    .notes {
      margin-top: 1rem;

      .card {
        margin-bottom: 1rem;

        .card-block {
          overflow: hidden;
          padding: .5rem 1rem;
          text-overflow: ellipsis;
          white-space: pre-line;
        }

        .card-header {
          align-items: center;
          background-color: #eceff1;
          display: flex;
          justify-content: space-between;
          padding: .5rem 1rem;
        }
      }
    }
  }

  .title-wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .toolbar {
    display: flex;
    flex-wrap: wrap;

    .toolbar-item {
      align-items: center;
      display: flex;
      flex-grow: 1;
      margin: 0 0 0 2rem;

      @media (max-width: 991px) {
        margin: 0.2rem 0 0;
        width: 100%;
      }

      .button {
        width: 100%;

        .button-inner {
          display: flex;

          i {
            margin-inline-end: 0.5rem;
          }
        }
      }
    }
  }
}

html[dir="ltr"] {
  .page-leadedit {
    .toolbar {
      .toolbar-item {
        margin: 0 2rem 0 0;

        @media (max-width: 991px) {
          margin: 0.2rem 0 0;
        }
      }
    }
  }
}
</style>
